// Select the top navigation bar and the hero wrapper
const topNav = document.getElementById('topNav');
const heroWrapper = document.querySelector('.hero-wrapper');
// Create an intersection observer to watch the hero wrapper
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        // If hero wrapper is NOT intersecting (meaning it's scrolled out of view), show the nav
        if (!entry.isIntersecting) topNav.style.top = '0';
        else // If hero wrapper IS visible, hide the nav
        topNav.style.top = '-100px';
    });
}, {
    threshold: 0
});
if (heroWrapper && topNav) observer.observe(heroWrapper);
// ================= SKILLS CAROUSEL =================
function initSkillsCarousel() {
    const track = document.getElementById('skillsTrack');
    const dots = document.querySelectorAll('#skillsDots .dot');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    if (!track || !dots.length) return;
    let currentIndex = 0;
    const totalSlides = dots.length;
    let autoPlayInterval;
    function updateCarousel() {
        const percentage = -(currentIndex * 100);
        track.style.transform = `translateX(${percentage}%)`;
        dots.forEach((dot, index)=>{
            if (index === currentIndex) dot.classList.add('active');
            else dot.classList.remove('active');
        });
    }
    function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateCarousel();
    }
    function prevSlide() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateCarousel();
    }
    function goToSlide(index) {
        currentIndex = index;
        updateCarousel();
    }
    function startAutoPlay() {
        stopAutoPlay();
        autoPlayInterval = setInterval(nextSlide, 5000);
    }
    function stopAutoPlay() {
        if (autoPlayInterval) clearInterval(autoPlayInterval);
    }
    // Event Listeners
    if (nextBtn) nextBtn.addEventListener('click', ()=>{
        nextSlide();
        startAutoPlay(); // Reset timer
    });
    if (prevBtn) prevBtn.addEventListener('click', ()=>{
        prevSlide();
        startAutoPlay(); // Reset timer
    });
    dots.forEach((dot, index)=>{
        dot.addEventListener('click', ()=>{
            goToSlide(index);
            startAutoPlay(); // Reset timer
        });
    });
    // Start auto-play initially
    startAutoPlay();
}
// ================= SERVICES CAROUSEL (MOBILE) =================
function initServicesCarousel() {
    const track = document.getElementById('servicesTrack');
    const dots = document.querySelectorAll('#servicesDots .dot');
    const prevBtn = document.getElementById('servicesPrevBtn');
    const nextBtn = document.getElementById('servicesNextBtn');
    if (!track || !dots.length) return;
    let currentIndex = 0;
    const totalSlides = dots.length;
    // Touch handling variables
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    function updateCarousel(animate = true) {
        const percentage = -(currentIndex * 100);
        track.style.transition = animate ? 'transform 0.4s ease-out' : 'none';
        track.style.transform = `translateX(${percentage}%)`;
        dots.forEach((dot, index)=>{
            if (index === currentIndex) dot.classList.add('active');
            else dot.classList.remove('active');
        });
    }
    function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateCarousel();
    }
    function prevSlide() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateCarousel();
    }
    function goToSlide(index) {
        currentIndex = index;
        updateCarousel();
    }
    // Button Event Listeners
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    // Dots Event Listeners
    dots.forEach((dot, index)=>{
        dot.addEventListener('click', ()=>goToSlide(index));
    });
    // Touch/Swipe Event Listeners
    const viewport = track.parentElement;
    viewport.addEventListener('touchstart', (e)=>{
        touchStartX = e.touches[0].clientX;
        isDragging = true;
        startTranslate = -(currentIndex * 100);
        track.style.transition = 'none';
    }, {
        passive: true
    });
    viewport.addEventListener('touchmove', (e)=>{
        if (!isDragging) return;
        touchEndX = e.touches[0].clientX;
        const diff = touchEndX - touchStartX;
        const viewportWidth = viewport.offsetWidth;
        const percentDiff = diff / viewportWidth * 100;
        currentTranslate = startTranslate + percentDiff;
        track.style.transform = `translateX(${currentTranslate}%)`;
    }, {
        passive: true
    });
    viewport.addEventListener('touchend', ()=>{
        if (!isDragging) return;
        isDragging = false;
        const diff = touchEndX - touchStartX;
        const threshold = 50; // Minimum swipe distance
        if (diff > threshold && currentIndex > 0) // Swiped right - go to previous
        prevSlide();
        else if (diff < -threshold && currentIndex < totalSlides - 1) // Swiped left - go to next
        nextSlide();
        else // Snap back to current slide
        updateCarousel();
        // Reset touch values
        touchStartX = 0;
        touchEndX = 0;
    });
}
// Initialize Carousel when DOM is ready
document.addEventListener('DOMContentLoaded', ()=>{
    initSkillsCarousel();
    initServicesCarousel();
    initPortfolioCarousel();
    initProgressBarAnimation();
});
// ================= PORTFOLIO CAROUSEL (MOBILE) =================
function initPortfolioCarousel() {
    const track = document.getElementById('portfolioTrack');
    const dots = document.querySelectorAll('#portfolioDots .dot');
    const prevBtn = document.getElementById('portfolioPrevBtn');
    const nextBtn = document.getElementById('portfolioNextBtn');
    if (!track || !dots.length) return;
    let currentIndex = 0;
    const totalSlides = dots.length;
    // Touch handling variables
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    function updateCarousel(animate = true) {
        const percentage = -(currentIndex * 100);
        track.style.transition = animate ? 'transform 0.4s ease-out' : 'none';
        track.style.transform = `translateX(${percentage}%)`;
        dots.forEach((dot, index)=>{
            if (index === currentIndex) dot.classList.add('active');
            else dot.classList.remove('active');
        });
    }
    function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateCarousel();
    }
    function prevSlide() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateCarousel();
    }
    function goToSlide(index) {
        currentIndex = index;
        updateCarousel();
    }
    // Button Event Listeners
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    // Dots Event Listeners
    dots.forEach((dot, index)=>{
        dot.addEventListener('click', ()=>goToSlide(index));
    });
    // Touch/Swipe Event Listeners
    const viewport = track.parentElement;
    viewport.addEventListener('touchstart', (e)=>{
        touchStartX = e.touches[0].clientX;
        isDragging = true;
        startTranslate = -(currentIndex * 100);
        track.style.transition = 'none';
    }, {
        passive: true
    });
    viewport.addEventListener('touchmove', (e)=>{
        if (!isDragging) return;
        touchEndX = e.touches[0].clientX;
        const diff = touchEndX - touchStartX;
        const viewportWidth = viewport.offsetWidth;
        const percentDiff = diff / viewportWidth * 100;
        currentTranslate = startTranslate + percentDiff;
        track.style.transform = `translateX(${currentTranslate}%)`;
    }, {
        passive: true
    });
    viewport.addEventListener('touchend', ()=>{
        if (!isDragging) return;
        isDragging = false;
        const diff = touchEndX - touchStartX;
        const threshold = 50;
        if (diff > threshold && currentIndex > 0) prevSlide();
        else if (diff < -threshold && currentIndex < totalSlides - 1) nextSlide();
        else updateCarousel();
        touchStartX = 0;
        touchEndX = 0;
    });
}
// ================= SKILLS PROGRESS ANIMATION =================
// ================= SKILLS PROGRESS ANIMATION =================
function initProgressBarAnimation() {
    const skillsBlock = document.querySelector('.skills-right');
    const progressBars = document.querySelectorAll('.skill-bar-fill');
    if (!skillsBlock || !progressBars.length) return;
    // Helper to animate numbers
    const runNumberAnimation = (element, endValue, duration)=>{
        let startTimestamp = null;
        const step = (timestamp)=>{
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            // Stop if animation was cancelled (e.g. scrolled out)
            if (element.getAttribute('data-animating') !== 'true') return;
            element.textContent = Math.floor(progress * endValue) + "%";
            if (progress < 1) window.requestAnimationFrame(step);
        };
        element.setAttribute('data-animating', 'true');
        window.requestAnimationFrame(step);
    };
    // 1. Prepare bars: Store target width and set initial width to 0
    progressBars.forEach((bar)=>{
        const targetWidth = bar.style.width;
        bar.setAttribute('data-target-width', targetWidth);
        // Setup percent text
        const percentSpan = bar.querySelector('.skill-percent');
        if (percentSpan) {
            const targetNum = parseInt(targetWidth) || 0;
            percentSpan.setAttribute('data-target-num', targetNum);
            percentSpan.textContent = "0%";
        }
        bar.style.width = '0';
        bar.style.transition = 'width 1.5s ease-out';
    });
    // 2. Observer to trigger animation
    const progressObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) // Animate bars and numbers
            progressBars.forEach((bar)=>{
                bar.style.width = bar.getAttribute('data-target-width');
                const percentSpan = bar.querySelector('.skill-percent');
                if (percentSpan) {
                    const targetNum = parseInt(percentSpan.getAttribute('data-target-num'));
                    runNumberAnimation(percentSpan, targetNum, 1500);
                }
            });
            else // Reset bars and text when out of view
            progressBars.forEach((bar)=>{
                bar.style.width = '0';
                const percentSpan = bar.querySelector('.skill-percent');
                if (percentSpan) {
                    percentSpan.setAttribute('data-animating', 'false'); // Stop loop
                    percentSpan.textContent = "0%";
                }
            });
        });
    }, {
        threshold: 0.5
    });
    progressObserver.observe(skillsBlock);
}
// ================= PREVENT BROWSER ZOOM =================
// Prevent zoom with Ctrl+Scroll to avoid layout breaking
document.addEventListener('wheel', function(e) {
    if (e.ctrlKey) e.preventDefault();
}, {
    passive: false
});
// Also prevent zoom with Ctrl+Plus/Minus
document.addEventListener('keydown', function(e) {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) e.preventDefault();
}, {
    passive: false
});
// ================= MOBILE MENU TOGGLE =================
const burgerBtn = document.getElementById('burgerBtn');
const mobileMenu = document.getElementById('mobileMenu');
const mobileLogo = document.getElementById('mobileLogo');
const mobileMenuLinks = document.querySelectorAll('.mobile-menu-link');
if (burgerBtn && mobileMenu && mobileLogo) {
    // Toggle menu on burger click
    burgerBtn.addEventListener('click', ()=>{
        burgerBtn.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        mobileLogo.classList.toggle('hidden');
        // Prevent body scroll when menu is open
        if (mobileMenu.classList.contains('active')) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
    });
    // Close menu when clicking on a link
    mobileMenuLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            mobileLogo.classList.remove('hidden');
            document.body.style.overflow = '';
        });
    });
}

//# sourceMappingURL=WEB_3C.16d1fc4b.js.map
